/*
 * @Description: 门户路由
 * @Author: kecraft
 * @Date: 2023-11-12 10:45:59
 * @LastEditors: kecraft
 * @LastEditTime: 2024-08-21 15:10:57
 * @FilePath: /custom-website-desk/src/router/router.js
 */
import { createRouter, createWebHistory } from "vue-router";
// import home from "@/views/index.vue";

const routes = [
  {
    path: "/",
    component: () => import("@/views/gateWay/index.vue"),
    redirect: "/index",
    children: [
      {
        path: "index",
        name: "门户首页",
        component: () => import("@/views/home/index.vue"),
      },
      {
        path: "groupOverview",
        name: "集团概况",
        component: () => import("@/views/groupOverview/index.vue"),
      },
      {
        path: "newsCenter",
        name: "新闻中心",
        component: () => import("@/views/newsCenter/index.vue"),
      },
      {
        path: "featureColumn",
        name: "专题专栏",
        component: () => import("@/views/featureColumn/index.vue"),
      },
      {
        path: "blockBusiness",
        name: "板块业务",
        component: () => import("@/views/blockBusiness/index.vue"),
      },
      {
        path: "enterpriseCulture",
        name: "企业文化",
        component: () => import("@/views/enterpriseCulture/index.vue"),
      },
      {
        path: "informationOpen",
        name: "信息公开",
        component: () => import("@/views/informationOpen/index.vue"),
      },
      // {
      //   path: "onLineReporting",
      //   name: "网上举报",
      //   component: () => import("@/views/onLineReporting/index.vue"),
      // },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(
    process.env.VUE_APP_ISDOMAIN === "true" ? "/" : "/h5/"
  ),
  routes,
});

//路由守卫
// router.beforeEach((to, from, next) => {
//     if (to.path === '/login') return next()
//     if (to.path.indexOf("gateWay") > -1) return next()  //门户不需要token
//     const tokenstr = localStorage.getItem("charge_operator_token")
//     if (!tokenstr) return next('/login')
//     next()
// })
export default router;
